export default __webpack_public_path__ + "static/media/fishButton.18f2bce1.png";